import Planet from "./Planet";
import { useState } from "react";

const Main = () => {

    const [weight, setWeight] = useState(1);

    function changeHandler(e) {
        e.preventDefault();
        setWeight(e.target.value);
    }

    const planets = [
        {
            "name": "Sun",
            "gravity": 27.01
        },
        {
            "name": "Mercury",
            "gravity": 0.38
        },
        {
            "name": "Venus",
            "gravity": 0.91
        },
        {
            "name": "Earth",
            "gravity": 1
        },
        {
            "name": "Moon",
            "gravity": 0.166
        },
        {
            "name": "Mars",
            "gravity": 0.38
        },
        {
            "name": "Jupiter",
            "gravity": 2.34
        },
        {
            "name": "Saturn",
            "gravity": 1.06
        },
        {
            "name": "Uranus",
            "gravity": 0.92
        },
        {
            "name": "Neptune",
            "gravity": 1.19
        },
        {
            "name": "Pluto",
            "gravity": 0.06
        }]


    return (
        <>
            <label htmlFor="weight">Your Weight: </label>
            <input onChange={changeHandler} id="weight" type="text" placeholder="1"></input>
            <p>It doesn’t matter whether you use pounds or kilograms because the conversion factor is the same.</p>
            <div className="planets">
                {planets.map((planet, index) => {

                    return (

                        <Planet key={index} weight={weight} gravity={planet.gravity} planetName={planet.name}></Planet>

                    )
                })}
            </div>
        </>
    )
}

export default Main;